import { Note } from '@/components/common/note'
import { InfoIcon } from '@/components/icons/info'

export const YoRedeemNote = () => {
  return (
    <Note>
      <div className="flex items-center gap-2">
        <InfoIcon />
        <h6 className="font-bold">Insufficient liquidity</h6>
      </div>
      <p className="text-xs">
        The amount you are trying to redeem is greater than the instantly available liquidity. The request will be
        processed within 24 hours.
      </p>
    </Note>
  )
}
